import { StyleSheet } from 'react-native';

export const footballerFlagStyles = StyleSheet.create({
  image: { borderRadius: 3 },
});
